
export interface FetchStudiesResponse {
  status: boolean;
  message: string;
  data: StudiesListDataResponse;
}

export interface StudiesDataResponse {
  id: number;
  date: Date;
  studyTypeName: string;
  institutionName: string;
  medicName: string;
  pacient: string;
  age: number;
  date_birth: Date;
  date_study: string;
  file_measures: string;
  fullname: string;
  imageCapturedBy: number;
  images_3D: File[];
  img_transversal: File[];
  institution_id: number;
  institution_name: string | null;
  medic_id: number;
  patient_id: number;
  previous_studies: number[];
  selected_color: string[];
  stackedCrossSections: File[];
  studyType: string;
  study_type_id: number;
}
export interface studyResponse {
  id: number;
  date: Date;
  studyTypeName: string;
  institutionName: string;
  medicName: string;
  pacient: string;
  age: number;
  date_birth: Date;
  date_study: string;
  file_measures: string;
  fullname: string;
  imageCapturedBy: number;
  images_3D: File[];
  img_transversal: File[];
  institution_id: number | string | null;
  medic_id: number;
  patient_id: number;
  previous_studies: number[];
  selected_color: string[];
  stackedCrossSections: File[];
  studyType: string;
  study_type_id: number;
}



// Study
export interface Study {
  id: number;
  name: string;
}

// response
export interface StudiesListResponse {
  msg: string;
  result: Study[];
}

// request
export interface StudiesListRequest {
  study_type_id: number;
}
//request dateStudy
export interface DateStudyRequest {
  date_study: Date | string; 
}

// study response date
export interface DateStudyResponse {
  success: boolean;
  message?: string;
}

// study 3D images
export interface StudyImages3D {
  img1: string;
  img2: string;
  img3: string;
}



// new study response
export interface newStudyRequest {
  study_type_id: number | null;
  patient_id: number | null;
  date_study: string;
  medic_id: number | null;
  institution_id: number | null;
  scanner_id: string;
  previous_studies: number[] | null;
  '3D_image': File[];
  individual_cross_sections: File[];
  selected_color: [];
  stackedCrossSections: File[] | null;
  measures: string;
}


export interface editStudyRequest {
  study_type_id: number;
  fullname: string;
  patient_id: number;
  age: number;
  date_birth: string ;
  date_study: string;
  medic_id: number | null;
  institution_id: number | string | null;
  imageCapturedBy: number;
  previous_studies: number | null;
  images_3D: File[];
  img_transversal: File[];
  selected_color: [];
  stackedCrossSections: File[] | null;
  file_measures: string;
}

export interface PreviousStudy {
  id: number;
  name: string;
  captured_by: string; 
  institution: string; 
  study_date: string;
}

export interface PreviousStudyResponse {
  status: boolean;
  message: string;
  data: PreviousStudy[];
}

export interface NewStudyResponse extends commonResponse {
  data: NewStudyResponseData
}

export interface NewStudyResponseData {
  id: number,
  study_type_id: string,
  studyTypeName: string,
  patient_id: string,
  patient: string,
  age: number,
  date_birth: string,
  medic_id: string,
  medicName: string,
  study_date: string,
  institution_id: string,
  institutionName: string,
  scanner_id: string,
  scanner_model: string,
  images_3D: string[],
  individual_cross_sections: string,
  measures: string,
  previous_studies: number[]
}

export interface StudiesListDataResponse {
  current_page: number;
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: number | null;
  to: number;
  total: number;
  data: StudiesListData[];
  links: StudiesListLinks[];
}

export interface StudiesListData {
  id: number;
  InstitutionName: string;
  Institution_id: number;
  medicName: string;
  medic_id: string;
  patient: string;
  patient_id: number;
  study_date: string;
  studyTypeName: string;
}

export interface StudiesListLinks {
  active: boolean;
  label: string;
  url: string | null;
}

export interface StudiesListColItem {
  id: number;
  study_date: string;
  studyTypeName: string;
  InstitutionName: string | null;
  medicName: string;
  patient: string;
}

export interface commonResponse {
  status: boolean;
  message: string;
}

export interface StudyTypeRespose extends commonResponse {
  data: Study[]
}